import { FC } from 'react'
import { useTranslate } from 'react-polyglot'
import { MenuItem } from '@getgo/chameleon-web-react-wrapper'
import { Grid } from '@material-ui/core'

import { ManagedAccountsByPartner } from 'hooks/useManagedAccounts'
import { Account } from 'types/Account'
import { useStyles } from './AccountMenuForPartners'
import Section, { MenuSection } from './Section'

interface SearchResultProps {
  filter: string
  setFilter: (filter: string) => void
  managedAccountsByPartner: ManagedAccountsByPartner[]
  onSelectAccount: (account: Account) => void
}

const SearchResult: FC<SearchResultProps> = ({
  filter,
  setFilter,
  managedAccountsByPartner,
  onSelectAccount,
  ...props
}) => {
  const t = useTranslate()
  const classes = useStyles()

  const filteredSections: MenuSection[] = managedAccountsByPartner
    .map((managedAccounts) => ({
      title: `${t('Customer Accounts')} - ${managedAccounts.partnerAccount.name}`,
      accounts: managedAccounts.customerAccounts.filter((account: Account) =>
        account.name.toLowerCase().includes(filter.toLowerCase()),
      ),
    }))
    .filter((section) => section.accounts.length)

  return (
    <Grid data-testid="search-result" className={classes.accountListFilterHolder} item xs {...props}>
      {filteredSections.length ? (
        filteredSections.map((section) => (
          <Section key={`${section.title}-${section.accounts.length}`} {...section} onClick={onSelectAccount} />
        ))
      ) : (
        <MenuItem data-testid="search-result-no-account-found" onClick={() => setFilter('')}>
          {t('No account found')}
        </MenuItem>
      )}
    </Grid>
  )
}

export default SearchResult
